<template>
  <div class="beian"  :class="{'lineHeight':$store.state.totleIsShow==false}">
      <div v-show="$store.state.totleIsShow==true" class="totle">共 {{$store.state.tabCount[1]+$store.state.tabCount[2]+$store.state.tabCount[3]+$store.state.tabCount[4]}} 份资料</div>
      <a :href="jumpURL($store.state.beianMsg.site_gwa)"  target="_blank">
        <p >
            {{$store.state.beianMsg.site_icp}}
        </p>
      </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
    //   home: '',
    }
  },
  created(){
      if(this.$store.state.beianMsg==""){
          this.$store.commit('getBeian')
      }else{
          return;
      }
      
  },
  methods:{
      jumpURL(url){
         return url;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .beian{
       height:50px;
       /* line-height: 50px; */
       background:#fff;
   }
   a{
       text-decoration: none;
       font-size:12px;
       color:#999;
   }
   .lineHeight{
       line-height: 50px;
   }
   .totle{
       color: #999;
       font-size:14px;
       line-height: 24px;
   }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue